module.exports = __webpack_public_path__ + "img/step_1.e4721fef.svg";